import React from "react"
import { graphql } from "gatsby"
import NewLayout from "../components/new_layout"
import SEO from "../components/seo"
import MainSection100 from "../components/Layout/main-section-100"
import { Container } from "../components/Layout/containers"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import Tag from "../components/v2023/UI/Tag/tag"
import LinkButton from "../components/v2023/UI/LinkButton/link-button"
import ImageGroup from "../components/v2024/image/image-group"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import ReadyToTalk from "../components/v2023/ReadyToTalk/ready-to-talk"
import MenuModalState from "../components/v2024/Login/modal-login-state"
import ItemGroup from "../components/v2023/UI/Item/item-group"
import { Tabs } from "../components/v2024/tabs"
import { ResponsiveImage } from "../components/v2024/responsive-image"
import { DemoSteps } from "../components/v2024/demo-steps"
import ModalLogin from "../components/v2024/Login/modal-login"

const FacturaElectronica = ({ data, pageContext }) => {
    const page = data.page
    const lang = pageContext.langKey
    const loginModalStatus = MenuModalState()

    const tabs = [
        {
            id: 'web',
            title: page.tab_web_title,
            content: <div className="tabs__content-column">
                <div className="tabs__content-column__50">
                    <h2>{page.tab_web_items.title}</h2>
                    <div className="container__text">
                        <ReactMarkdown children={page.tab_web_items.description} rehypePlugins={[rehypeRaw]} />
                    </div>
                    <button className="button button--xl" onClick={() => loginModalStatus.openMenu()}>
                        {page.tab_web_items.button[0].text}
                    </button>
                </div>
                <div className="tabs__content-column__50">
                    <GatsbyImage image={getImage(page.tab_web_items.image.localFile)} alt={page.tab_web_items.image.alternativeText} />
                </div>
            </div>
        },
        {
            id: 'api',
            title: page.tab_api_title,
            content: <div className="tabs__content-column">
                <div className="tabs__content-column__50">
                    <h2>{page.tab_api_items.title}</h2>
                    <div className="container__text">
                        <ReactMarkdown children={page.tab_api_items.description} rehypePlugins={[rehypeRaw]} />
                    </div>
                    <LinkButton button={page.tab_api_items.button[0]} className="button button--xl" />
                </div>
                <div className="tabs__content-column__50">
                    {page.tab_api_items.image &&
                        <GatsbyImage image={getImage(page.tab_api_items.image.localFile)} alt={page.tab_api_items.image.alternativeText} />
                    }
                </div>
            </div>
        }
    ]

    return (
        <NewLayout pageContext={pageContext}>
            <SEO
                lang={lang}
                title={page.seo.title}
                description={page.seo.meta_description}
                translates={pageContext.translates}
                image={page.seo.image_2.localFile.publicURL}
            />
            {/* HERO SECTION */}
            <MainSection100 sectionColor="purple-dark" sectionType="color" hero frameGray noContainer>
                <Container>
                    <div data-aos="fade-up">
                        {page.tag.map((tag, index) => (
                            <Tag tag={tag} key={index} />
                        ))}
                    </div>
                    <div className="container__text" data-aos="fade-up">
                        <h1 className="hero">{page.title}</h1>
                        <ReactMarkdown children={page.description} rehypePlugins={[rehypeRaw]} />
                        <div className="button__wrapper">
                            <button className="button button--ghost button--xxl" onClick={() => loginModalStatus.openMenu()}>
                                {page.start_free_button.text}
                            </button>
                            <LinkButton button={page.pricing_button} className="button button--secondary button--secondary--ghost button--xl" />
                        </div>
                    </div>
                </Container>
                <Container np animation="fade-up">
                    <div className="hidden-sm">
                        <DemoSteps demoSteps={page.demo_steps} category="factura-electronica">
                            <ResponsiveImage image1440={page.hero_image} image992={page.hero_image} image768={page.hero_image_mobile} image576={page.hero_image_mobile} />
                        </DemoSteps>
                    </div>
                    {/* DEMO STEPS MOBILE */}
                    <div className="show-sm">
                        <DemoSteps demoSteps={page.demo_steps_mobile} category="factura-electronica">
                            <ResponsiveImage image1440={page.hero_image} image992={page.hero_image} image768={page.hero_image_mobile} image576={page.hero_image_mobile} />
                        </DemoSteps>
                    </div>
                </Container>
                <Container center animation="fade-up">
                    <div className="grid-lg-3-h">
                        {page.characteristics.map((characteristic, index) => (
                            <ImageGroup
                                basicInfoWithImage={characteristic}
                                key={index}
                                xs={true}
                                animation={{ "data-aos": "zoom-in", "data-aos-delay": 200 * index }}
                            />
                        ))}
                    </div>
                </Container>
            </MainSection100>
            {/* FUNCTIONALITIES SECTION */}
            <MainSection100>
                <h2>{page.functionalities_title}</h2>
                 <div className="container__text">
                    <ReactMarkdown children={page.functionalities_description} rehypePlugins={[rehypeRaw]} />
                </div>
                <ItemGroup items={page.functionalities_items} hasImage unboxed />
            </MainSection100>
            {/* VERIFACTU SECTION */}
            <MainSection100>
                <h2>{page.verifactu_title}</h2>
                <div className="container__text">
                    <ReactMarkdown children={page.verifactu_description} rehypePlugins={[rehypeRaw]} />
                </div>
                <ResponsiveImage image1440={page.verifactu_image} image992={page.verifactu_image} image768={page.verifactu_image_768} image576={page.verifactu_image_576} />
            </MainSection100>
            {/* TABS SECTION */}
            <MainSection100>
                <Tabs small tabs={tabs} />
            </MainSection100>
            {/* FEATURES SECTION */}
            <MainSection100 sectionType="color" sectionColor="gray  gray--noframe">
                <Tag tag={page.features_tag} />
                <h2>{page.features_title}</h2>
                <div className="container__text">
                    <ReactMarkdown children={page.features_description} rehypePlugins={[rehypeRaw]} />
                </div>
                <div className="grid-lg-4">
                    {page.features_items.map((item, index) => {
                        const isLast = index === page.features_items.length - 1
                        const animation = { "data-aos": "zoom-in", "data-aos-delay": 200 * index }
                        return <div className={`tile-icon ${isLast ? "tile-icon--highlight" : ""}`} {...animation} key={index}>
                            <div className="tile-icon__image">
                                <GatsbyImage
                                    alt={item.image.alternativeText}
                                    image={getImage(item.image.localFile)}
                                    placeholder="blurred"
                                    quality={100}
                                />
                            </div>
                            <div className="tile-icon__body">
                                <h5>{item.title}</h5>
                                <span>
                                    <ReactMarkdown children={item.description} rehypePlugins={[rehypeRaw]} />
                                </span>
                            </div>
                            {item.button?.text && item.button?.url && (
                                <div className="tile-icon__action">
                                    <LinkButton button={item.button} className={"link--big"} extras={<i className="icon-arrow-right"></i>} />
                                </div>
                            )}
                        </div>
                    })}
                </div>
            </MainSection100>
            {/* TRUST SECTION */}
            <MainSection100>
                <div className="tag tag--status tag--status--lg">
                    <i className="icon-rocket"></i>
                    {page.ad_hoc_tag}
                </div>
                <h2>{page.ad_hoc_title}</h2>
                <div className="container__text">
                    <ReactMarkdown children={page.ad_hoc_description} rehypePlugins={[rehypeRaw]} />
                </div>
                <div className="grid-lg-4">
                    {page.ad_hoc_items.map((item, index) => (
                        <ImageGroup basicInfoWithImage={item} key={index} noTitle />
                    ))}
                </div>
            </MainSection100>
            {/* FAQ SECTION */}
            <MainSection100 containerSlim>
                <h3>{page.faq_title}</h3>
                <ItemGroup items={page.faq_items} unboxed />
            </MainSection100>
            {/* READY TO TALK */}
            {/* <ReadyToTalk lang={lang} /> */}
            <MainSection100>
                <div className="ready-to-talk-simple">
                    <ReadyToTalk lang={lang} hideTags />
                </div>
            </MainSection100>
            {/* MODALS */}
            <ModalLogin
                lang={lang}
                state={loginModalStatus}
                plan={page.start_free_form}
                selectedPlan="factura_free"
            />
        </NewLayout>
    )
}

export default FacturaElectronica

export const facturaElectronicaQuery = graphql`
	query ($langKey: String) {
		page: strapi2025FacturaElectronica(locale: { eq: $langKey }) {
			seo {
				title
				meta_description
				image_2 {
					localFile {
						publicURL
					}
				}
			}
			tag {
				name
				type
			}
			title
			description
			start_free_button {
				text
				url
				blank
			}
			pricing_button {
				text
				url
				blank
			}
			demo_steps {
                order
                title
                description
                image {
                    name
                    alternativeText
                    localFile {
                        childImageSharp {
                            gatsbyImageData(
                                width: 704, 
                                placeholder: BLURRED, 
                                formats: [WEBP],
                                quality: 100,
                                breakpoints: [636, 576, 520, 512, 350]
                            )
                        }
                    }
                }
            }
            demo_steps_mobile {
                order
                title
                description
                image {
                    name
                    alternativeText
                    localFile {
                        childImageSharp {
                            gatsbyImageData(
							    width: 670
                                placeholder: BLURRED,
                                formats: [WEBP],
                                breakpoints: [636, 512, 350]
                            )
                        }
                    }
                }
            }
			hero_image {
				localFile {
					childImageSharp {
						gatsbyImageData(
							width: 1440
							placeholder: NONE
							formats: [WEBP]
							breakpoints: [1440, 992, 928, 768, 704, 636, 576, 520, 512, 350]
						)
					}
				}
				alternativeText
			}
			hero_image_mobile {
				localFile {
					childImageSharp {
						gatsbyImageData(
							width: 704
							placeholder: NONE
							formats: [WEBP]
							breakpoints: [704, 636, 576, 520, 512, 350]
						)
					}
				}
				alternativeText
			}
			characteristics {
				title
				description
				image {
					localFile {
						childImageSharp {
							gatsbyImageData(width: 80, placeholder: BLURRED, formats: [WEBP])
						}
					}
				}
			}
			functionalities_title
			functionalities_description
			functionalities_items {
			    id	    
                description
				title
				icon {
                    name
                    alternativeText
					localFile {
						childImageSharp {
							gatsbyImageData(
                                width: 608, 
                                placeholder: BLURRED, 
                                formats: [WEBP], 
                                breakpoints: [512, 350]
                            )
						}
					}
				}
			}
			verifactu_title
			verifactu_description
			verifactu_image {
				localFile {
					childImageSharp {
						gatsbyImageData(
							width: 1384 
							placeholder: NONE
							formats: [WEBP]
                            quality: 100
							breakpoints: [928, 704, 636, 520, 512, 350]
						)
					}
				}
			}
            verifactu_image_576 {
				localFile {
					childImageSharp {
						gatsbyImageData(
							width: 576
							placeholder: NONE
							formats: [WEBP]
							breakpoints: [520, 512, 350]
						)
					}
				}
			}
            verifactu_image_768 {
				localFile {
					childImageSharp {
						gatsbyImageData(
							width: 768
							placeholder: NONE
							formats: [WEBP]
							breakpoints: [636, 520, 512, 350]
						)
					}
				}
			}
			tab_web_title
			tab_web_items {
				order
				title
				description
				image {
					localFile {
						childImageSharp {
							gatsbyImageData(
								width: 608
								placeholder: NONE
								formats: [WEBP]
								breakpoints: [520, 512, 350]
							)
						}
					}
				}
				button {
					text
					url
					blank
				}
			}
			tab_api_title
			tab_api_items {
				order
				title
				description
				image {
					localFile {
						childImageSharp {
							gatsbyImageData(
								width: 608
								placeholder: NONE
								formats: [WEBP]
								breakpoints: [520, 512, 350]
							)
						}
					}
				}
				button {
					text
					url
					blank
				}
			}
			features_tag {
				name
				type
			}
			features_title
			features_description
			features_items {
				title
				description
				button {
					text
					url
					blank
				}
				image {
					localFile {
						childImageSharp {
							gatsbyImageData(width: 80, placeholder: NONE, formats: [WEBP])
						}
					}
				}
			}
			ad_hoc_tag
			ad_hoc_title
			ad_hoc_description
			ad_hoc_items {
				description
				image {
					localFile {
						childImageSharp {
                                gatsbyImageData(
                                width: 440, 
                                placeholder: NONE, 
                                formats: [WEBP]
                                breakpoints: [314, 280]
                            )
						}
					}
				}
			}
			faq_title
			faq_items {
				id
				title
				description
			}
            start_free_form {
                form_email
                or_sign_up
                login_text
                form_name
                form_tc_description
                form_repassword
                form_password
                title
                description
                button_google
                button_email
                form_lastname
                signup_text
                button_signup
                button_login
                remember_me
                forgot_password
                title_login
                description_login
                form_tc_info
            }
		}
	}
`
